import React from 'react';
import Hero from './components/infrastructure/Hero';
import Main from './components/infrastructure/Main';

const Infrastructure = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Infrastructure;